module.exports = __webpack_public_path__ + "img/test_Icon16.77840861.png";